function createElement(node, classname) {
	const element = document.createElement(node);
	element.classList.add(classname);
	return element;
}

export default createElement;
